import * as React from "react";
import { forwardRef } from "react";
const SvgAngleRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M6 18.9l6.9-6.9L6 5.1 8.1 3l9 9-9 9z" }));
const ForwardRef = forwardRef(SvgAngleRight);
export default ForwardRef;
